import Text from '@components/Text';
import styled from '@emotion/styled';
import { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement>{
    isError?: boolean;
    contentsClassName?: string;
}

function Description(props: Props) {
    const {
        children, isError, contentsClassName, ...rest
    } = props;
    return (<Container isError={isError}
        {...rest} >
        <DescriptionText size='body-long'
            isError={isError}
            className={contentsClassName}
            as='div'>
            {children}
        </DescriptionText>
    </Container>);
}

const Container = styled.div<{
    isError?: boolean;
}>`
    align-items: center;
    background-color: ${({ isError }) => (isError ? 'var(--color-background-error)' : 'var(--color-background-base)')};
    border-radius: 8px;
    column-gap: 8px;
    display: flex;
    padding: 12px;
    width: 100%;

    li {
        font-size: 15px;
        line-height: 23px;
        list-style: '•';
        margin-left: 6px;
        padding-left: 6px;
    }
`;

const DescriptionText = styled(Text, {
    shouldForwardProp: (prop) => prop !== 'isError',
})<{
    isError?: boolean;
}>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ isError }) => (isError ? 'var(--color-text-error)' : 'var(--color-text-primary)')};
`;

export default Description;
